import React, { useEffect } from 'react';
import Resizer from "react-image-file-resizer";
import { AdsPOSTApi, AdsPUTApi, ImageURL, MediaUpload } from '../../../Constant/api';
import { slugs } from '../../../Constant/slugs';
import { useSelector } from 'react-redux';

export default function FileUpload(props) {
  const {
    ImageUrl,
    setImageUrl,
    ResultData,
    ExamData
  } = props;
  const fileRefSingle = React.createRef();
  const [Loading, setLoading] = React.useState(false)
  const [URL, setURL] = React.useState("")

  const MediaUploadSingleCall = (file, i) => {
    if (!file) return;
    var fileInput = "";
    // if (file) {
    //   fileInput = file.type;
    // }
    // console.log("2", file)
    var fileInput = "";
    if (file) {
      fileInput = file.type;
    }
    console.log("2", file)

    const name = file.name.toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace("pdf", "1.pdf")
    const file2 = new File([file], name);

    MediaUpload(file2)
      .then(res => res.json())
      .then(data => {
        setImageUrl(data.source_url)
        setURL(data.source_url)
        ResultUpload(data.source_url)
      })
      .catch(err => {
        setLoading(false)
        console.log("error", err.message);
      })
  }
  const LoginState = useSelector((state) => state.LoginState);

  const ResultUpload = (url) => {

    if (ResultData.id == 0)
      AdsPOSTApi({
        status: "publish",
        meta: {
          "submitted_pdf": `${url}`,
          "return_pdf": "",
          "exam_id": `${ExamData.id}`,
          "exam_name": `${ExamData.title.rendered}`,
          "exam_pdf": `${ExamData.meta.pdf}`,
          "exam_image": `${ExamData.meta.image}`,
          "user_id": `${LoginState.userID}`,
          "user_name": `${LoginState.userName}`,
          "user_email": `${LoginState.userEmail}`,
          "checked_by": "",
          "submitted_date": "",
          "marks_obtained": "",
          "full_marks": ""
        }
      }, slugs.db_slug_written_exam_results)
        .then(res => {
          setTimeout(() => {
            setLoading(false)
            window.location.reload()
          }, 1000);
        })
    else
      AdsPUTApi({
        "submitted_pdf": `${url}`,
        "return_pdf": "",
        "exam_id": `${ExamData.id}`,
        "exam_name": `${ExamData.title.rendered}`,
        "exam_pdf": `${ExamData.meta.pdf}`,
        "exam_image": `${ExamData.meta.image}`,
        "user_id": `${LoginState.userID}`,
        "user_name": `${LoginState.userName}`,
        "user_email": `${LoginState.userEmail}`,
        "checked_by": "",
        "submitted_date": "",
        "marks_obtained": "",
        "full_marks": ""
      }, slugs.db_slug_written_exam_results, ResultData.id)
        .then(res => {
          setTimeout(() => {
            setLoading(false)
            window.location.reload()
          }, 1000);
        })

  }

  return (
    <div>
      {Loading &&
        <div className="spinner-border"></div>
      }
      <div className="col-lg-6 col-md-6">
        <div className="row">
          {ImageUrl !== "" ?
            <div className="col-3 my-2">
              <div className=" ">
                <audio controls>
                  {/* <source src={`${ImageUrl}`} type="audio/ogg" /> */}
                  <source src={`${ImageUrl}`} type="audio/mpeg" />
                  <source src={`${ImageUrl}`} type="audio/mp3" />
                  <source src={`${ImageUrl}`} type="audio/wav" />
                  <source src={`${ImageUrl}`} type="audio/ogg" />
                  Your browser does not support the audio element.
                </audio>
              </div>
              <button onClick={() => {
                setImageUrl("")
              }}
                className="bg-transparent border-0 p-1 "
              ><u>Clear</u></button>
            </div>
            :
            <div className="col-3">
              <button type="button"
                onClick={() => {
                  fileRefSingle.current.click()
                }}
                className="bg-transparent border-0 p-1 "
              >
                <div className="border border-dark m-1 p-4 font-size-12">
                  <i className="fa fa-file-pdf-o font-size-18"></i>
                  <div>Add PDF File</div>
                </div>
              </button>
            </div>
          }
        </div>
      </div>
      <div style={{ display: 'none' }}>
        <input type="file" accept="file/*" name="image" id="file" ref={fileRefSingle}
          onChange={(event) => {
            if (event.target.files.length !== 0) {
              setLoading(true)
              MediaUploadSingleCall(event.target.files[0])
            }
          }}
        />
      </div>
      {/* <div style={{ fontSize: "8px", color: "#777" }}>
        The pdf or book uploaded should not have the copyright with some other company or party.<br></br>
        Please try not to upload pdfs that may later have compyright issues
      </div> */}
    </div>
  )
}